import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import AppLayout from "@/components/feature/AppLayout";
import AuthGuard from "@/components/feature/AuthGuard";
import LoginPage from "@/pages/auth/LoginPage";
import RegisterPage from "@/pages/auth/RegisterPage";
import DashboardPage from "@/pages/dashboard/page";
import NewReportPage from "@/pages/reports/NewReportPage";
import ReportListPage from "@/pages/reports/ReportListPage";
import ReportDetailPage from "@/pages/reports/ReportDetailPage";
import StatisticsPage from "@/pages/statistics/page";
import EditReportPage from "@/pages/reports/EditReportPage";
import MonthlyReportPage from "@/pages/statistics/MonthlyReportPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: "report/new",
        element: <NewReportPage />,
      },
      {
        path: "report/:id",
        element: <ReportDetailPage />,
      },
      {
        path: "report/:id/edit",
        element: <EditReportPage />,
      },
      {
        path: "reports",
        element: <ReportListPage />,
      },
      {
        path: "statistics",
        element: <StatisticsPage />,
      },
      {
        path: "statistics/report",
        element: <MonthlyReportPage />,
      },
    ],
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;